import React from 'react';
import Typography from '@mui/material/Typography';
import MarkPage from './MarkPage';
import PageTabs from '../../tool/doc/PageTabs';
import { FixMe } from '../../../types/util';
import { IDocument, IField, IGroundTruth, IToken } from '../../../types/my-types';
import { MarkDispatchContext, MarkStateContext } from '../../../context/MarkContext';
import { getMisMatchedIndexTokens } from '../../../utils/getMismatchedTokens';
import { styled } from '@mui/system';

const DivRoot = styled('div')({
  flexGrow: 1,
  width: '100%',
});

const TypographyWarning = styled(Typography)(({ theme }) => ({
  color: theme.palette.warning.main,
}));

const getFieldLabel = (url: string, fields: IField[]) => {
  const found = fields.find((f) => f.url === url);
  if (found) {
    return found.label;
  }
  return '';
};

const getMarkedTokens = (groundTruths: IGroundTruth[], fields: IField[]) => {
  // TODO: filter by page number
  // flatten groundTruths to token
  // add field label to token

  let markedTokens: IToken[] = [];
  if (Array.isArray(groundTruths)) {
    markedTokens = groundTruths
      .map((g: IGroundTruth) => {
        // TODO: remove this condition after api fixed the format
        if (g.token_data && Array.isArray(g.token_data)) {
          return g.token_data.map((t: IToken) => ({
            ...t,
            field_label: getFieldLabel(g.field, fields),
          }));
        } else if (g.token_data && Array.isArray(g.token_data.tokens)) {
          return g.token_data.tokens.map((t: IToken) => ({
            ...t,
            field_label: getFieldLabel(g.field, fields),
          }));
        } else {
          return [];
        }
      })
      .reduce((acc, val) => acc.concat(val), []);
  }
  return markedTokens;
};

export interface MarkContentProps {
  doc: IDocument;
  fields: IField[];
  groundTruths: IGroundTruth[];
  tokenPages: FixMe[];
}

const MarkContent: React.FC<MarkContentProps> = ({ doc, fields, groundTruths, tokenPages }) => {
  const { pageIndex, misMatchedIndexTokens } = React.useContext(MarkStateContext);
  const dispatch = React.useContext<React.Dispatch<any>>(MarkDispatchContext);

  const markedTokens = React.useMemo(
    () => getMarkedTokens(groundTruths, fields),
    [groundTruths, fields]
  );

  const pageReady = doc.pages && doc.pages.length > 0 && tokenPages[pageIndex];

  React.useEffect(() => {
    dispatch({
      type: 'SET_MISMATCHED_INDEX_TOKENS',
      payload: getMisMatchedIndexTokens(markedTokens, tokenPages),
    });
  }, [pageIndex, markedTokens, tokenPages, dispatch]);

  return (
    <DivRoot>
      <PageTabs pages={doc.pages} docLabel={doc.label} documentId={doc.id} />
      {pageReady ? (
        <MarkPage
          pageUrl={doc.pages[pageIndex]}
          page={tokenPages[pageIndex]}
          markedTokens={markedTokens}
          doc={doc}
          fields={fields}
          groundTruths={groundTruths}
        />
      ) : (
        <TypographyWarning>
          GENERATING DOCUMENT PAGES... PLEASE CONTACT OUR GLYNT SUPPORT TEAM IF IT TOOK MORE THAN
          ONE MINUTE.
        </TypographyWarning>
      )}
    </DivRoot>
  );
};

export default MarkContent;
